import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import Personalizer from 'personalizer';
import Loadable from 'utils/extensions/Loadable';
import ModelSynchronizer from 'utils/ModelSynchronizer';
import ViewerUserPreferences from 'models/user/ViewerUserPreferences';
import SystemMessage from 'models/system/SystemMessage';
import templateHtml from 'templates/main/SystemMessagePageView.html';

var Events = {
    SYSTEM_MESSAGE_RENDERED: 'SYSTEM_MESSAGE_RENDERED'
};

var LoadableView = Backbone.View.extend(Loadable);
var SystemMessagePageView = LoadableView.extend({
    propertyFiles: ['/system-messages/system-messages'],

    initialize: function(args) {
        this.template = _.template(templateHtml);
        this.systemMessage = new SystemMessage();
        this.systemMessageText = args.systemMessageText;
        this.shouldDisplayMessages = args.shouldDisplayMessages;

        this.viewerUserPreferences = ViewerUserPreferences;
    },

    render: function() {
        var systemMessages = [];
        var sysMsg = this.systemMessage.get('value');

        if (this.shouldDisplayMessages) {
            if (jQuery.trim(sysMsg).length > 0) {
                systemMessages.push(this.getMessage(sysMsg));
            }

            if (jQuery.trim(this.systemMessageText).length > 0) {
                systemMessages.push(this.systemMessageText);
            }
        }

        this.$el.html(
            this.template({
                Localizer: Localizer,
                Personalizer: Personalizer,
                systemMessages: systemMessages
            })
        );

        this.$el.attr('id', 'system-message');
    },

    getMessage: function(msg) {
        var translateThis = Localizer.localize('translateThis');
        var locale = this.viewerUserPreferences.get('preferredLocale');
        var isEnglish = locale == 'en';

        if (!isEnglish) {
            var translateThisUrl =
                'http://translate.google.com/?hl=' + locale + '#en|' + locale + '|' + encodeURIComponent(msg);
            var translateThisLink =
                '<a href="' +
                translateThisUrl +
                '" target="_blank"><span style="font-size: 10px;">' +
                translateThis +
                '</span></a>';
            msg += ' ' + translateThisLink + '.';
        }

        return msg;
    },

    onDependenciesLoaded: function() {
        var sysMsg = this.systemMessage.get('value');

        if (jQuery.trim(sysMsg).length > 0 || jQuery.trim(this.systemMessageText).length > 0) {
            this.render();
        }

        this.trigger(Events.SYSTEM_MESSAGE_RENDERED);
    },

    onModelsFailed: function() {
        if (typeof console != 'undefined' && typeof console.log != 'undefined') {
            console.log(arguments);
        }
    },

    provideDependencies: function(modelSynchronizer) {
        modelSynchronizer.addModel({ model: this.systemMessage, required: true });

        modelSynchronizer.bind(ModelSynchronizer.Events.SYNCHRONIZED, this.onDependenciesLoaded, this);
        modelSynchronizer.bind(ModelSynchronizer.Events.SYNCHRONIZE_FAILED, this.onModelsFailed, this);
    }
});

SystemMessagePageView.Events = Events;
export default SystemMessagePageView;
